import { WeekDay } from "../../types/time";

/** The cadence choices the payroll-schedule radio group offers. */
export enum PayrollCadenceOption {
  Monthly = "Monthly",
  SemiMonthly = "SemiMonthly",
  Everyday = "Everyday",
  Week = "Week"
}

/**
 * `PayrollScheduleUpdate.interval` takes any N, but the payroll engine is only
 * known to honour weekly and biweekly, so the design's free-number input stays
 * capped rather than letting a payer type 3 and receive a schedule nobody runs.
 * Tracked as gap G-CAD-N.
 */
export const MAX_WEEK_INTERVAL = 2;

export type PayrollCadenceFormData = {
  interval: PayrollCadenceOption;
  every: number;
  dayInInterval: WeekDay;
};
